module.exports = __webpack_public_path__ + "7009680e0198aeca55966d8cf6269634.svg";